var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/core-js/modules/_validate-collection.js
// module id = 619
// module chunks = 8